const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgroIconBrown19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.77 41.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "54.22 17.15 30.27 32.53 30.27 41.51 57.77 23.82 54.22 17.15",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 23.82 27.51 41.51 27.51 32.53 3.57 17.12 0 23.82",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.89,0L5.62,14.96l23.27,14.97,23.29-14.96L28.89,0Zm0,9.22l-11.58,7.45-2.9-1.86,14.49-9.32,14.49,9.32-2.9,1.86-11.58-7.45Z",
    style: {
      fill: "#a26128"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroIconBrown19);
export default __webpack_public_path__ + "static/media/agro-icon-brown-19.434d83fbd145f6ca6c781e6e1b74225a.svg";
export { ForwardRef as ReactComponent };